import { ref, type Ref } from "vue";

const investmentsRefreshCount = ref<number>(0);
const providerImportsRefreshCount = ref<number>(0);

export type UseDataRefresh = {
    refreshInvestments: () => void;
    refreshProviderImports: () => void;
	investmentsCount: Ref<number>;
	providerImportsCount: Ref<number>;
}

export const useDataRefresh = (): UseDataRefresh => {
    const refreshInvestments = () => {
        investmentsRefreshCount.value = investmentsRefreshCount.value + 1;
    }
    const refreshProviderImports = () => {
        providerImportsRefreshCount.value = providerImportsRefreshCount.value + 1;
    }
    return {
        refreshInvestments,
        refreshProviderImports,
		investmentsCount: investmentsRefreshCount,
		providerImportsCount: providerImportsRefreshCount
    }
}

export const globalDataRefresh = useDataRefresh();

export const refreshInvestments = () => {
	investmentsRefreshCount.value = investmentsRefreshCount.value + 1;
}

export const refreshProviderImports = () => {
	providerImportsRefreshCount.value = providerImportsRefreshCount.value + 1;
}

export { investmentsRefreshCount, providerImportsRefreshCount };